import { LessonCourseDefaultThumbnail } from '@/constant/imgImport';
import { ComponentPropsWithoutRef } from 'react';
import { TPaymentCardCourse } from '../types';

const CoursePaymentCardThumbnail = ({
  thumbnail,
  ...restImgProps
}: {
  thumbnail: TPaymentCardCourse['dataContext']['thumbnail'];
} & ComponentPropsWithoutRef<'img'>) => {
  return (
    <img
      {...restImgProps}
      src={thumbnail || LessonCourseDefaultThumbnail}
      alt="course thumbnail"
      className={`aspect-[1.75] h-[187px] w-full rounded-[10px] object-cover xl:h-[156px] ${restImgProps.className}`}
      loading="lazy"
      decoding="async"
    />
  );
};

export default CoursePaymentCardThumbnail;
